var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$vuetify.breakpoint.mobile)?_c('FornitoriDesktop'):_c('v-row',{staticClass:"mt-12",attrs:{"justify":"center"}},[_vm._v("Non disponibile per mobile")])}
var staticRenderFns = []

export { render, staticRenderFns }